import React from "react";
import {
    Tooltip as MuiTooltip,
    TooltipProps as MuiTooltipProps,
    tooltipClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export type TooltipPlacement =
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top-start"
    | "top-end"
    | "bottom-start"
    | "bottom-end"
    | "left-start"
    | "left-end"
    | "right-start"
    | "right-end";

export interface TooltipProps extends Omit<MuiTooltipProps, "title"> {
    title?: React.ReactNode;
    children: React.ReactElement;
    placement?: TooltipPlacement;
    className?: string;
}

const StyledTooltip = styled(({ className, ...props }: MuiTooltipProps) => (
    <MuiTooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{ popper: { sx: { zIndex: 100300 } } }}
        arrow
    />
))(({ theme }) => ({
    "&.MuiTooltip-popper": {
        zIndex: "100300 !important" as any,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#1e293b", // slate-800
        color: "#f8fafc", // slate-50
        boxShadow:
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        fontSize: "12px",
        fontWeight: 600,
        padding: "6px 12px",
        borderRadius: "8px",
        border: "1px solid #334155", // slate-700
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#1e293b",
        "&::before": {
            border: "1px solid #334155",
        },
    },
}));

export const Tooltip: React.FC<TooltipProps> = ({
    title,
    children,
    placement = "top",
    ...props
}) => {
    if (!title) {
        return <>{children}</>;
    }

    return (
        <StyledTooltip title={title} placement={placement} {...props}>
            {children}
        </StyledTooltip>
    );
};

export default Tooltip;
